export default __webpack_public_path__ + "static/media/energy.3abc9baf.png";